/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SubscriptionPlanDto } from '../models/SubscriptionPlanDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SubscriptionPlanRestControllerService {
  /**
   * getSubscriptionPlans
   * @returns SubscriptionPlanDto OK
   * @throws ApiError
   */
  public static getSubscriptionPlansUsingGet(): CancelablePromise<Array<SubscriptionPlanDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/subscription-plan',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getFeatures
   * @returns string OK
   * @throws ApiError
   */
  public static getFeaturesUsingGet(): CancelablePromise<
    Array<
      | 'ATTENDANCE'
      | 'CBT'
      | 'EXPENSES'
      | 'FEES_MANAGEMENT'
      | 'INVENTORY_MANAGEMENT'
      | 'LESSON_PLAN'
      | 'MESSAGING'
      | 'PARENT_MANAGEMENT'
      | 'PAYROLL'
      | 'RESULT_MANAGEMENT'
      | 'STAFF_MANAGEMENT'
      | 'STUDENT_MANAGEMENT'
    >
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/subscription-plan/features/all',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getSubscriptionPlan
   * @returns SubscriptionPlanDto OK
   * @throws ApiError
   */
  public static getSubscriptionPlanUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<SubscriptionPlanDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/subscription-plan/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
